//#region src/js/accordion.js
var accordionGroupSelector = "[data-accordion-group]";
var accordionTargetSelector = "[data-accordion-target]";
var accordionTriggerSelector = "[data-accordion-trigger]";
var menuDrawerSelector = "menu-drawer";
var accordionGroups = document.querySelectorAll(accordionGroupSelector);
function getDirectAccordionTarget(accordionGroup) {
	return accordionGroup.querySelector(`:scope > ${accordionTargetSelector}`) || accordionGroup.querySelector(accordionTargetSelector);
}
function getElementDepth(element) {
	let depth = 0;
	for (let parent = element; parent; parent = parent.parentElement) depth += 1;
	return depth;
}
function resizeOpenMenuDrawerAccordions() {
	const menuDrawer = document.querySelector(menuDrawerSelector);
	if (!menuDrawer) return;
	Array.from(menuDrawer.querySelectorAll(`${accordionGroupSelector}.open`)).sort((firstGroup, secondGroup) => getElementDepth(secondGroup) - getElementDepth(firstGroup)).forEach((accordionGroup) => {
		const accordionTarget = getDirectAccordionTarget(accordionGroup);
		if (!accordionTarget) return;
		accordionTarget.style.maxHeight = `${accordionTarget.scrollHeight}px`;
	});
}
function resizeMenuDrawerAfterLayoutSettles() {
	resizeOpenMenuDrawerAccordions();
	requestAnimationFrame(() => {
		resizeOpenMenuDrawerAccordions();
		requestAnimationFrame(resizeOpenMenuDrawerAccordions);
	});
}
function resizeOpenParentAccordions(accordionGroup) {
	for (let parent = accordionGroup.parentElement; parent;) {
		const parentAccordion = parent.closest(accordionGroupSelector);
		if (!parentAccordion) break;
		const parentTarget = getDirectAccordionTarget(parentAccordion);
		if (parentAccordion.classList.contains("open") && parentTarget) parentTarget.style.maxHeight = `${parentTarget.scrollHeight}px`;
		parent = parentAccordion.parentElement;
	}
}
function refreshAccordionHeights(accordionGroup) {
	if (accordionGroup.closest(menuDrawerSelector)) {
		resizeMenuDrawerAfterLayoutSettles();
		return;
	}
	resizeOpenParentAccordions(accordionGroup);
}
function openAccordion(accordionGroup) {
	const accordionTarget = getDirectAccordionTarget(accordionGroup);
	if (!accordionTarget) return;
	accordionGroup.classList.add("open");
	accordionTarget.style.maxHeight = `${accordionTarget.scrollHeight}px`;
	refreshAccordionHeights(accordionGroup);
}
function closeAccordionOnly(accordionGroup) {
	const accordionTarget = getDirectAccordionTarget(accordionGroup);
	accordionGroup.classList.remove("open");
	if (accordionTarget) accordionTarget.style.maxHeight = null;
}
function closeAccordion(accordionGroup) {
	accordionGroup.querySelectorAll(accordionGroupSelector).forEach(closeAccordionOnly);
	closeAccordionOnly(accordionGroup);
	refreshAccordionHeights(accordionGroup);
}
function closeNestedSiblingAccordions(accordionGroup) {
	accordionGroup.parentElement.querySelectorAll(`:scope > ${accordionGroupSelector}`).forEach((siblingAccordion) => {
		if (siblingAccordion !== accordionGroup) closeAccordion(siblingAccordion);
	});
}
function closeRootMenuDrawerAccordions(accordionGroup) {
	accordionGroups.forEach((otherAccordionGroup) => {
		const isCurrentAccordion = otherAccordionGroup === accordionGroup;
		const isNestedAccordion = otherAccordionGroup.closest(accordionTargetSelector);
		if (!isCurrentAccordion && !isNestedAccordion) closeAccordion(otherAccordionGroup);
	});
}
function closeOtherAccordions(accordionGroup) {
	const isInMenuDrawer = accordionGroup.closest(menuDrawerSelector);
	const parentElement = accordionGroup.parentElement;
	if (!isInMenuDrawer) {
		accordionGroups.forEach(closeAccordion);
		return;
	}
	if (parentElement?.matches(accordionTargetSelector)) {
		closeNestedSiblingAccordions(accordionGroup);
		return;
	}
	closeRootMenuDrawerAccordions(accordionGroup);
}
function initializeAccordion(accordionGroup) {
	const accordionTrigger = accordionGroup.querySelector(accordionTriggerSelector);
	const accordionTarget = getDirectAccordionTarget(accordionGroup);
	if (!accordionTrigger || !accordionTarget) return;
	accordionTrigger.addEventListener("click", () => {
		if (accordionTarget.style.maxHeight) {
			closeAccordion(accordionGroup);
			return;
		}
		closeOtherAccordions(accordionGroup);
		openAccordion(accordionGroup);
	});
	if (!accordionTarget.closest(menuDrawerSelector)) return;
	accordionTarget.addEventListener("transitionend", (event) => {
		if (event.propertyName === "max-height") resizeOpenMenuDrawerAccordions();
	});
}
accordionGroups.forEach(initializeAccordion);
//#endregion
